import { defineStore } from 'pinia';
import { API } from '@/script/api';

import { replaceFacesVm } from '@/vm/faceswap_vm';
import { Config } from '@/script/config';
import { User } from '@/script/user';
import { useTxtToImgTaskManager } from './useTxtToImgTaskManager';
import { compileString } from 'sass';

export const useTxtToImg = defineStore('txtToImg', {
    state: () => {
        return {
            // 提交历史
            submitHistory: [],
            // 推荐提示
            suggestionPrompts: [],
            // 风格列表
            styles: [],
            // 批量列表
            batchSizes: [],
            // 二维数组
            hintTags: [],

            suggestionPromptLoadStatus: API.REQUEST_STATUS_NONE,
            stylesLoadStatus: API.REQUEST_STATUS_NONE,
            replaceFacesLoadStatus: API.REQUEST_STATUS_NONE,
            hintTagLoadStatus: API.REQUEST_STATUS_NONE,

            currentStyleIndex: 0,
            currentFaceIndex: 0,
            currentBatchSizeIndex: 0,
            currentTagCategoryIndex: 0,
            // 
            currentRatioIndex: 0,

            prompt: '',
            hasUserChangedPrompt: false,
        }
    },
    getters: {
        /// 所有人脸头像
        faces: (state) => {
            return replaceFacesVm.faces
        },
        /// 当前选中style是否为写实
        currentRealisticStyle: (state) => {
            try {
                return state.styles[state.currentStyleIndex].styleKey == 'realistic'
            } catch (_) {
                return false
            }
        },
        /// 当前ratio选中索引转成接口字段值
        currentRatioAPIValue: (state) => {
            switch (state.currentRatioIndex) {
                case 1:
                    return '11'
                case 2:
                    return '32'
                default:
                    return '23'
            }
        },
        /// 是否有最近使用tag
        hasRecentHintTag: (state) => {
            return state.hintTags[0].titleKey == 'recent'
        },
        /// 是否可以提交换脸任务
        submitEnable: (state) => {
            return state.prompt.length > 0
        },
        
        /// 当前需要积分数
        useCredisCount: (state) => {
            let count = 1
            if (state.currentRealisticStyle) {
                const face = replaceFacesVm.faces[state.currentFaceIndex]
                if (!face.demoFlag) {
                    count = 2
                }
            }
            return count * state.batchSizes[state.currentBatchSizeIndex]
        },
        /// hintTag模块当前选中类别下的tags
        currentCategoryTags: (state) => {
            return state.hintTags[state.currentTagCategoryIndex]
        },
    },
    actions: {
        // 重置prompt
        clearPrompt () {
            this.prompt = '';
        },
        setPrompt(text) {
            this.prompt = text;
        },
        /// 初始化
        init() {
            // 从本地加载恢复部分初始数据
            const jsonStr = localStorage['flutter.stored_items_json']
            if (jsonStr) {
                const submitHistory = JSON.parse(jsonStr)
                this.submitHistory.push(...submitHistory)
            }

            // 各模块数据拉取
            this.loadSuggestionRandom()
            this.loadSuggestionPrompts()
            this.loadStyles()
            this.loadFaces()
            this.loadHintTags()


            // 处理初始batchSize
            this.updateBatchSize()

            if (User.getInstance.isLogin.value) {
                User.getInstance.loadUserInfo()
            }
            Config.getInstance.loadConfig().then(() => {
                this.updateBatchSize()
            })
        },
        /// 更新当前style选中索引
        changeCurrentStyleIndex(index) {
            this.currentStyleIndex = index
        },
        /// 更新当前looks like人脸选中索引
        changeCurrentFaceIndex(index) {
            this.currentFaceIndex = index
        },
        /// 更新当前batch size选中索引
        changeCurrentBatchSizeIndex(index) {
            this.currentBatchSizeIndex = index
        },
        /// 更新当前hint tag类别选中索引
        changeCurrentTagCategoryIndex(index) {
            this.currentTagCategoryIndex = index
        },
        /// 使用历史提交记录填充数据
        useSubmitHistoryItem(history) {
            this.prompt = history.submitPrompt
            this.currentStyleIndex = Math.max(0, this.styles.indexOf((e) => e.styleKey == history.selectedStyleKey))
            this.currentFaceIndex = Math.max(0, this.faces.indexOf((e) => e.id == history.selectedFaceId))
            this.currentRatioIndex = history.selectedImageRatio == "23" ? 0 : (history.selectedImageRatio == "11" ? 1 : 2)
        },
        /// 获取一次随机Prompt
        async loadSuggestionRandom() {
            try {
                // 跳转有提示词的时候不请求
                if(this.prompt !== '') {
                    return
                }
                const resp = await API.getSuggestionRandom()
                const keyword = resp?.data?.suggestion?.suggestionKeyword
                if (keyword && !this.hasUserChangedPrompt) {
                    this.prompt = keyword
                }
            } catch (_) { }
        },
        /// 获取推荐prompt提示词列表
        async loadSuggestionPrompts() {
            this.suggestionPromptLoadStatus = API.REQUEST_STATUS_LOADING
            try {
                this.suggestionPrompts.splice(0, this.suggestionPrompts.length)
                const resp = await API.getSuggestionList()
                if (resp.code == 200) {
                    this.suggestionPrompts.push(...resp.data.suggestions)
                    this.suggestionPromptLoadStatus = API.REQUEST_STATUS_SCUCESS
                } else {
                    this.suggestionPromptLoadStatus = API.REQUEST_STATUS_FAILED
                }
            } catch (_) {
                this.suggestionPromptLoadStatus = API.REQUEST_STATUS_FAILED
            }
        },
        /// 选中suggestion prompt
        selecteSuggestionPrompt(suggestionPrompt) {
            this.prompt = suggestionPrompt.suggestionKeyword
            for (const item of this.suggestionPrompts) {
                item.selected = false
            }
            suggestionPrompt.selected = true
        },
        /// 清除当前suggestion prompt选中状态
        unselectSuggestionPrompt() {
            for (const item of this.suggestionPrompts) {
                item.selected = false
            }
        },
        /// 获取style列表
        async loadStyles() {
            this.stylesLoadStatus = API.REQUEST_STATUS_LOADING
            try {
                this.styles.splice(0, this.styles.length)
                const resp = await API.getStyleList()
                if (resp.code == 200) {
                    this.styles.push(...resp.data.styles)
                    this.stylesLoadStatus = API.REQUEST_STATUS_SCUCESS
                } else {
                    this.stylesLoadStatus = API.REQUEST_STATUS_FAILED
                }
            } catch (_) {
                this.stylesLoadStatus = API.REQUEST_STATUS_FAILED
            }
        },
        /// 拉取looks like人脸列表
        async loadFaces() {
            this.replaceFacesLoadStatus = API.REQUEST_STATUS_LOADING
            await replaceFacesVm.loadFaces()
            this.replaceFacesLoadStatus = replaceFacesVm.loadStatus.value
        },
        /// 上传looks like人脸
        async uploadFace(file) {
            const res = await replaceFacesVm.uploadFace(file)
            if (res.length > 0) {
                this.currentFaceIndex += res.length
                return true
            }
            return false
        },
        /// 删除looks like 人脸
        async deleteFace(face) {
            const success = await replaceFacesVm.deleteFace(face)
            if (this.currentFaceIndex >= replaceFacesVm.faces.length) {
                this.currentFaceIndex = replaceFacesVm.faces.length - 1
            }
            return success
        },
        /// 获取hint tag列表
        async loadHintTags() {
            this.hintTagLoadStatus = API.REQUEST_STATUS_LOADING
            try {
                this.hintTags.splice(0, this.hintTags.length)
                const resp = await API.getHintTags()
                if (resp.code == 200) {
                    if (localStorage['recentHintTags']) {
                        this.hintTags.push(JSON.parse(localStorage['recentHintTags']))
                    }
                    this.hintTags.push(...resp.data.hinttags)
                    for (const category of this.hintTags) {
                        for (const tag of category.hintTagDetailInfoList) {
                            tag.selected = false
                        }
                    }
                    this.hintTagLoadStatus = API.REQUEST_STATUS_SCUCESS
                } else {
                    this.hintTagLoadStatus = API.REQUEST_STATUS_FAILED
                }
            } catch (_) {
                this.hintTagLoadStatus = API.REQUEST_STATUS_FAILED
            }
        },
        /// 选中tag
        selecteHintTag(tag) {
            tag.selected = true
            if (this.hasRecentHintTag) {
                const findIndex = this.hintTags[0].hintTagDetailInfoList.indexOf((e) => e.titleKey == tag.titleKey)
                if (findIndex) {
                    this.hintTags[0].hintTagDetailInfoList.splice(findIndex, 1)
                    this.hintTags[0].hintTagDetailInfoList.unshift(tag)
                } else {
                    this.hintTags[0].hintTagDetailInfoList.unshift(tag)
                }
                if (this.hintTags.length > 20) {
                    this.hintTags.splice(0, 20)
                }
            } else {
                const recentTag = {
                    titleKey: "recent",
                    titleValue: i18n.global.t('recent'),
                    hintTagDetailInfoList: [
                        tag,
                    ],
                }
                this.hintTags.unshift(recentTag)
                this.currentTagCategoryIndex += 1
            }
            const hintTagsStr = JSON.stringify(this.hintTags[0])
            localStorage['recentHintTags'] = hintTagsStr
        },
        /// 取消指定tag选中
        unselectHintTag(tag) {
            tag.selected = false
        },
        /// 取消所有tag选中状态
        unselectAllHintTag() {
            for (const category of this.hintTags) {
                for (const tag of category.hintTagDetailInfoList) {
                    tag.selected = false
                }
            }
        },
        /// 获取所有选中tag
        allSelectedTag() {
            let tags = []
            for (const category of this.hintTags) {
                for (const tag of category.hintTagDetailInfoList) {
                    tags.push(tag)
                }
            }
            return tags
        },
        /// 拼接所有选中tag成字符串
        joinAllSelectedTag() {
            return this.allSelectedTag().map((e) => e.tagValue).join(',')
        },
        /// 更新batchSize相关数据
        updateBatchSize() {
            this.batchSizes.splice(0, this.batchSizes.length)
            if (User.getInstance.hasPaid.value) {
                this.batchSizes.push(...Config.getInstance.paidBatchSize.value)
            } else {
                this.batchSizes.push(...Config.getInstance.freeBatchSize.value)
            }
            if (localStorage['txtToImgBatchSize']) {
                const findIndex = this.batchSizes.indexOf((e) => e == parseInt(localStorage['txtToImgBatchSize']))
                if (findIndex) {
                    this.currentBatchSizeIndex = findIndex
                } else {
                    this.currentBatchSizeIndex = this.batchSizes[this.batchSizes.length - 1]
                }
            }
        },
        /// 更新当前batchSize 索引
        changeCurrentBatchSize(index) {
            if (index >= this.batchSizes.length) {
                this.currentBatchSizeIndex = this.batchSizes.length - 1
            } else {
                this.currentBatchSizeIndex = index
            }
            localStorage['txtToImgBatchSize'] = this.batchSizes[this.currentBatchSizeIndex]
        },
        /// 提交任务
        async submit() {
            let submitPrompt = this.prompt;
            let tagStr = this.joinAllSelectedTag()
            if (tagStr) {
                submitPrompt += `, ${tagStr}`
            }
            const submitParams = {
                prompt: submitPrompt,
                styleKey: this.styles[this.currentStyleIndex].styleKey,
                ratio: this.currentRatioAPIValue,
                batch: this.batchSizes[this.currentBatchSizeIndex]
            }
            if (this.currentRealisticStyle) {
                submitParams['faceId'] = this.faces[this.currentFaceIndex].id
            }
            useTxtToImgTaskManager().submit(submitParams)

            this.submitHistory.unshift({
                submitPrompt: submitParams.prompt,
                selectedStyleKey: submitParams.styleKey,
                selectedFaceId: submitParams.faceId,
                selectedImageRatio: submitParams.ratio,
            })
            if (this.submitHistory.length > 10) {
                this.submitHistory.splice(0, 10)
            }
            localStorage.setItem('flutter.stored_items_json', JSON.stringify(this.submitHistory))
        }
    },
})